import { useScroll, MotionValue } from "framer-motion";
import { RefObject } from "react";

// framer-motion does not export ScrollOffset, so we define it locally
type ScrollOffset = Array<string>;

interface UseScrollProgressOptions {
  target?: RefObject<HTMLElement>;
  offset?: ScrollOffset;
}

interface ScrollProgress {
  progress: MotionValue<number>;
  scrollY: MotionValue<number>;
  scrollYProgress: MotionValue<number>;
}

// hook to track scroll progress of an element or the entire page
export function useScrollProgress(options: UseScrollProgressOptions = {}): ScrollProgress {
  const { target, offset = ["start end", "end start"] } = options;

  // get scroll values
  const scrollData = useScroll({
    target,
    // @ts-expect-error: Ignore type error from useScroll return type
    offset,
  });

  // for compatibility with existing code that expects a 'progress' value
  const progress = scrollData.scrollYProgress;

  return {
    progress,
    scrollY: scrollData.scrollY,
    scrollYProgress: scrollData.scrollYProgress,
  };
}

//  hook to get global page scroll progress
//  useful for WebGL background transitions
export function usePageScrollProgress(): MotionValue<number> {
  const { scrollYProgress } = useScroll();
  return scrollYProgress;
}
